import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DetalhesEmpreendimentoService {
  //Unidades
  unidadesDe() {
    const dataUnidadesDe = [
      { id: 5, description: '5' },
      { id: 21, description: '21' },
      { id: 51, description: '51' },
      { id: 101, description: '101' },
      { id: 501, description: '501' },
      { id: 1001, description: '1001' },
      { id: 1501, description: '1501' },
    ];
    return of(dataUnidadesDe);
  }
  unidadesAte() {
    const dataUnidadesAte = [
      {
        id: 20,
        description: '20',
      },
      {
        id: 50,
        description: '50',
      },
      {
        id: 100,
        description: '100',
      },
      {
        id: 500,
        description: '500',
      },
      {
        id: 1000,
        description: '1000',
      },
      {
        id: 1500,
        description: '1500',
      },
    ];
    return of(dataUnidadesAte);
  }

  //Blocos
  blocosDe() {
    const dataBlocosDe = [
      {
        id: 1,
        description: '1',
      },
      {
        id: 10,
        description: '10',
      },
      {
        id: 11,
        description: '11',
      },
    ];
    return of(dataBlocosDe);
  }
  blocosAte() {
    const dataBlocosAte = [
      {
        id: 10,
        description: '10',
      },
      {
        id: 20,
        description: '20',
      },
      {
        id: 999999999,
        description: 'Mais de 20',
      },
    ];
    return of(dataBlocosAte);
  }

  //Pavimentos
  pavimentosDe() {
    const dataPavimentosDe = [
      {
        id: 2,
        description: '2',
      },
      {
        id: 5,
        description: '5',
      },
      {
        id: 10,
        description: '10',
      },
      {
        id: 20,
        description: '20',
      },
    ];
    return of(dataPavimentosDe);
  }
  pavimentosAte() {
    const dataPavimentosAte = [
      {
        id: 5,
        description: '5',
      },
      {
        id: 10,
        description: '10',
      },
      {
        id: 20,
        description: '20',
      },
      {
        id: 50,
        description: '50',
      },
      {
        id: 999999999,
        description: 'Mais de 50',
      },
    ];
    return of(dataPavimentosAte);
  }

  //Area Total
  areaTotalDe() {
    const dataAreaTotalDe = [
      {
        id: 201,
        description: '201',
      },
      {
        id: 1001,
        description: '1001',
      },
      {
        id: 5001,
        description: '5001',
      },
      {
        id: 10001,
        description: '10001',
      },
      {
        id: 20001,
        description: '20001',
      },
      {
        id: 50001,
        description: '50001',
      },
      {
        id: 100002,
        description: '100.001',
      },
    ];
    return of(dataAreaTotalDe);
  }
  areaTotalAte() {
    const dataAreaTotalAte = [
      {
        id: 1000,
        description: '1.000',
      },
      {
        id: 5000,
        description: '5.000',
      },
      {
        id: 10000,
        description: '10.000',
      },
      {
        id: 20000,
        description: '20.000',
      },
      {
        id: 50000,
        description: '50.000',
      },
      {
        id: 100000,
        description: '100.000',
      },
      {
        id: 200000,
        description: '200.000',
      },
      {
        id: 999999999,
        description: 'Mais de 200.000',
      },
    ];
    return of(dataAreaTotalAte);
  }

  //Mertro Quadrado Unidade
  metroQuadradoDe() {
    const dataMetroQuadradoDe = [
      {
        id: 1,
        description: 'Menos de 40',
      },
      {
        id: 61,
        description: '61',
      },
      {
        id: 101,
        description: '101',
      },
      {
        id: 161,
        description: '161',
      },
      {
        id: 261,
        description: '261',
      },
    ];
    return of(dataMetroQuadradoDe);
  }
  metroQuadradoAte() {
    const dataMetroQuadradoAte = [
      {
        id: 60,
        description: '60',
      },
      {
        id: 100,
        description: '100',
      },
      {
        id: 160,
        description: '160',
      },
      {
        id: 260,
        description: '260',
      },
      {
        id: 500,
        description: '500',
      },
      {
        id: 999999999,
        description: 'Mais de 500',
      },
    ];
    return of(dataMetroQuadradoAte);
  }

  //Banheiros
  banheirosDe() {
    const dataBanheirosDe = [
      {
        id: 1,
        description: 'Menos de 100',
      },
      {
        id: 101,
        description: '101',
      },
      {
        id: 501,
        description: '501',
      },
      {
        id: 1001,
        description: '1.001',
      },
      {
        id: 2001,
        description: '2.001',
      },
      {
        id: 3001,
        description: '3.001',
      },
    ];
    return of(dataBanheirosDe);
  }
  banheirosAte() {
    const dataBanheirosAte = [
      {
        id: 100,
        description: '100',
      },
      {
        id: 500,
        description: '500',
      },
      {
        id: 1000,
        description: '1.000',
      },
      {
        id: 2000,
        description: '2.000',
      },
      {
        id: 3000,
        description: '3.000',
      },
      {
        id: 4000,
        description: '4.000',
      },
      {
        id: 999999999,
        description: 'Mais de 4.000',
      },
    ];
    return of(dataBanheirosAte);
  }

  //Vagas
  vagasDe() {
    const dataVagasDe = [
      {
        id: 1,
        description: 'Menos de 100',
      },
      {
        id: 101,
        description: '101',
      },
      {
        id: 501,
        description: '501',
      },
      {
        id: 1001,
        description: '1.001',
      },
      {
        id: 2001,
        description: '2.001',
      },
      {
        id: 3001,
        description: '3.001',
      },
    ];
    return of(dataVagasDe);
  }
  vagasAte() {
    const dataVagasAte = [
      {
        id: 100,
        description: '100',
      },
      {
        id: 500,
        description: '500',
      },
      {
        id: 1000,
        description: '1.000',
      },
      {
        id: 2000,
        description: '2.000',
      },
      {
        id: 3000,
        description: '3.000',
      },
      {
        id: 4000,
        description: '4.000',
      },
      {
        id: 999999999,
        description: 'Mais de 4.000',
      },
    ];
    return of(dataVagasAte);
  }
  //Dormitórios
  dormitoriosDe() {
    const dataDormitoriosDe = [
      {
        id: 1,
        description: '1',
      },
      {
        id: 2,
        description: '2',
      },
      {
        id: 3,
        description: '3',
      },
      {
        id: 4,
        description: '4',
      },
      {
        id: 5,
        description: '5',
      },
    ];
    return of(dataDormitoriosDe);
  }
  dormitoriosAte() {
    const dataDormitoriosAte = [
      {
        id: 1,
        description: '1',
      },
      {
        id: 2,
        description: '2',
      },
      {
        id: 3,
        description: '3',
      },
      {
        id: 4,
        description: '4',
      },
      {
        id: 10,
        description: '10',
      },
      {
        id: 100,
        description: '100',
      },
      {
        id: 200,
        description: '200',
      },
    ];
    return of(dataDormitoriosAte);
  }
  //suites
  suitesDe() {
    const dataSuitesDe = [
      {
        id: 1,
        description: '1',
      },
      {
        id: 2,
        description: '2',
      },
      {
        id: 3,
        description: '3',
      },
      {
        id: 4,
        description: '4',
      },
      {
        id: 10,
        description: '10',
      },
    ];
    return of(dataSuitesDe);
  }
  suitesAte() {
    const dataSuitesAte = [
      {
        id: 1,
        description: '1',
      },
      {
        id: 2,
        description: '2',
      },
      {
        id: 3,
        description: '3',
      },
      {
        id: 4,
        description: '4',
      },
      {
        id: 10,
        description: '10',
      },
      {
        id: 100,
        description: '100',
      },
      {
        id: 200,
        description: '200',
      },
    ];
    return of(dataSuitesAte);
  }
}
